<template>
  <div style="text-align: left;">
		<div>
      
        <font style="color: red;" v-if="tb.ismust">*</font>
      <font style="color: red;" v-else="tb.ismust">&nbsp </font>
      {{tb.name}}</div>
     <div :style="'color:'+(tb.secondcolor?tb.secondcolor:'#ddd')">
       {{tb.secondname?tb.secondname:''}}
     </div>



  <div class=" weui-cells_checkbox" v-if="tb.csstype&&tb.csstype=='a'" style="display: flex;flex-wrap: wrap;align-content: center;">
    <div v-for="(item,key) in tb.boxdata" :style="'width:'+1/tb.csstypenum*100+'%;display: flex;'">
      <label  :for="tv+tb.name+key" style="display:flex;flex-direction: column;align-content: left;width: 95%; margin-top: 5px;" 
      :style="tb.border?'border: solid 1px #dddddd;':''"
      >
          <img  class="weui-cell__hd" v-if="tb.pic" :src="tb.pic?tb.pic[key].data:''"  alt="" style="width: 100%;">
          <label  class=" weui-check__label   noxiaoguo" style="display: flex;align-items: center;">
            <div class="weui-cell__hd" style="padding-right: 0px;padding-left: 0px;">          
              <input class="weui-check" :name="tv+tb.name" :id="tv+tb.name+key" v-model='picked' :value="item" type="radio">
              <i class="weui-icon-checked" :style="{color:picked===item?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}"></i>
          </div>
          <div  style="padding-left:0;padding-right: 0;" v-text="item" class="weui-cell__bd" 
          :style="{color:picked===item?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}">
            </div>
          </label>

      </label>
    </div>       
  </div> 








      <div class="weui-cells_checkbox" v-else>
        <template v-for="(item,key) in tb.boxdata">
        <label class="weui-cell weui-check__label noxiaoguo"  :for="tv+tb.name+key" :style="(tb.border?'border: solid 1px #dddddd;;':'')+'margin-top: 5px;'">
          <!-- <img src="/static/4.png" alt="" style="width: 15%;">  -->
         
          <img  v-if="tb.pic" :src="tb.pic?tb.pic[key].data:''" alt="" style="width: 15%;"> 
          <div class="weui-cell__hd">
                <input class="weui-check" :name="tv+tb.name" :id="tv+tb.name+key" v-model='picked' :value="item" type="radio">
                <i class="weui-icon-checked"  :style="{color:picked===item?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}"></i>
            </div>
            <div  v-text="item" class="weui-cell__bd"  :style="{color:picked===item?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}">

            </div>
        </label>
      </template>
    </div>








    <div v-if="tipdata">
      <div>
        <div class="weui-cell " style="border-bottom: 1px solid rgba(0,0,0,0.1);">
            <div class="weui-cell__bd" style="padding-bottom: 5px;padding-top: 5px;">
                <textarea class="weui-textarea" v-model="tipwrite" :placeholder="tipdata" rows="2" ></textarea>
                <a v-if="tipwrite" @click="tipwrite=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a> 
            </div>
        </div>
    </div>
    </div>


    
  </div>
</template>

<script>
  export default {
    props:['tb','tv','globalsetting'],
    name: 'Radio',
    data () {
      return {
        tipdata:"",
        tipwrite:"",
        picked:"",
      }
    },
    watch:{
      picked(n,o){
        if(this.picked==this.tb.val||!this.picked) return;
      if(this.tb.linkdata&&this.tb.linkdata.length!=0){
        let as =  this.tb.boxdata.findIndex(item=>item==this.picked);        
        this.tb.linkval = this.tb.linkdata[as];
      }
      if(this.tb.tipdata&&this.tb.tipdata.length!=0){
        let as = this.tb.boxdata.findIndex(item=>item==this.picked);        
        if(this.tb.tipdata[as]){
          this.tipdata = this.tb.tipdata[as];
        }else{
          this.tipdata = "";          
        }                
      }

      this.tipwrite = "";
      this.tb.val = this.picked;
     
  
      },
     tipwrite(n,o){
      if(this.tipdata){           
       this.tb.val = this.picked+(this.tipwrite?'|':'')+this.tipwrite;
     }else{
      this.tb.val = this.picked;
     }   
     },
     tbtemp(){
     
       this.picked = this.tb.val;
      
     } 
    },
    created(){
   
      setTimeout(()=>{
        this.picked = "";
        if(this.tb.val){        
        this.picked = this.tb.val;
      }
      },100)
    },
    activated(){
      
     
      setTimeout(()=>{
        this.picked = "";
        if(this.tb.val){       
        this.picked = this.tb.val;
      }
      },100)

    },
    computed:{
      tbtemp(){

        return this.tb.val;
      }
    }
    }

</script>

<style>
    .noxiaoguo:active{
  background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/fields/Radio.vue